exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ../~/css-loader!../~/less-loader/dist!./bricks/screen-size.less
// module id = 258
// module chunks = 0